<template>
    <header class="client-header">
        <img src="images/kevi-positivo-retina.png" alt="" />
        <a @click.prevent="$emit('logout')" class="logout">Sair</a>
        <span class="name">{{ client.firstname }}</span>
    </header>
</template>
<script>
export default {
    name: "client-header",
    props: {
        client: Object,
    },
    data: function () {
        return {};
    },
    methods: {},
};
</script>
